import React from 'react';
import classNames from 'classnames';
import {highlightText} from '../../../library/utils/highlightText';
import {Label} from '../../../../components/Common/Label/index';
import styles from '../../../../components/Common/FieldSearch/components/SearchOptionsV2/SearchOptions.module.scss';

interface RowProps {
    string1: string;
    string2: string;
    string3: string;
    searchQuery: string;
    ignorecase: boolean;
    searchFromBeginning: boolean;
}

export const NewTriggerRow = (props: RowProps) => {
    const {string1, string2, string3, searchQuery, ignorecase, searchFromBeginning} = props;

    return (
        <>
            <div className={styles.flexStartRow}>
                <Label
                    skin="paragraph-2"
                    textColor="primary-700"
                    componentClasses={styles.wrapline}
                >
                    {highlightText(string3, searchQuery, ignorecase, searchFromBeginning)}
                </Label>

                {string2 && string3 && (
                    <Label
                        skin="paragraph-2"
                        textColor="primary-700"
                        componentClasses={styles.bullet}
                    >
                        {'\u2022'}
                    </Label>
                )}

                <Label
                    skin="paragraph-2"
                    textColor="primary-700"
                    componentClasses={styles.wrapline}
                >
                    {highlightText(string2, searchQuery, ignorecase, searchFromBeginning)}
                </Label>
            </div>

            <Label skin="paragraph-2" textColor="secondary-400" componentClasses={styles.forceLtr}>
                {highlightText(string1, searchQuery, ignorecase, searchFromBeginning)}
            </Label>
        </>
    );
};

export const OldTriggerRow = (props: RowProps) => {
    const {string1, string2, searchQuery, ignorecase, searchFromBeginning} = props;
    return (
        <>
            <Label skin="paragraph-2" textColor="primary-700" componentClasses={styles.wrapline}>
                {highlightText(string1, searchQuery, ignorecase, searchFromBeginning)}
            </Label>

            <Label
                skin="paragraph-2"
                textColor="secondary-400"
                componentClasses={classNames(styles.wrapline, styles.secondOption)}
            >
                {string2}
            </Label>
        </>
    );
};
